import Vue from 'vue'
import Router from 'vue-router'
import Login from '../view/Login'
import Home from '../view/Home'
import secondView from '../components/device/secondView'
// import newDevice from '../components/device/NewDevice'
import newDevice from '../components/device/NewDevice1'
// import NewChildList from '../components/device/NewChildList'
import NewDeviceDetail from '../components/device/NewDeviceDetail'
import AmapNB from '../components/device/AmapNB'
import Events from '../components/event/Events'
import More from '../components/more/More'
import familyManagement from '../components/more/familyManagement'
import setFamilyItem from '../components/more/setFamilyItem'
import alarmNew from '../components/alarm/alarmNew'
import addDevice from '../components/addDevice/addDevice'
import videoPage from '../components/device/videoPage'
import mapCat from '../components/device/mapCat'
import payDetails from '../components/more/payDetails'
import payCenter from '../components/more/payCenter'
import packageDescribe from '../components/more/packageDescribe'
import simCardList from '../components/more/simCardList'
import deviceServiceList from '../components/more/deviceServiceList'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/Home',
      name: 'Home',
      component: Home,
      redirect: '/Device',
      children: [
        {path: '/Device', name: '设备', component: newDevice},
        {path: '/NewChildList', name: 'NewChildList', component: NewDeviceDetail},
        {path: '/secondView', name: 'secondView', component: secondView},
        // {path: '/Alarm', name: Alarm, component: Alarm},
        {path: '/Alarm', name: '报警', component: alarmNew},
        {path: '/Events', name: '事件', component: Events},
        {path: '/More', name: '用户', component: More},
        {path: '/AmapNB', name: 'AmapNB', component: AmapNB},
        {path: '/familyManagement', name: '场所列表', component: familyManagement},
        {path: '/setFamilyItem', name: '设置场所', component: setFamilyItem},
        {path: '/addDevice', name: '添加设备', component: addDevice},
        {path: '/videoPage', name: '视频通话', component: videoPage},
        {path: '/mapCat', name: '定位管理', component: mapCat},
        {path: '/payDetails', name: '支付详情', component: payDetails},
        {path: '/payCenter', name: '支付中心', component: payCenter},
        {path: '/packageDescribe', name: '套餐说明', component: packageDescribe},
        {path: '/simCardList', name: '我的流量卡', component: simCardList},
        {path: '/deviceServiceList', name: '流量卡续费', component: deviceServiceList}
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js